/* =========================================================
   Dolls In Love — Produktseite
   Inhalte kommen aus assets/js/dolls.js (Word-Dokument des Kunden)
   ========================================================= */
(function () {
  'use strict';

  const $  = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const doll = window.DIL_PRODUKT;
  if (!doll) return;


  /* --- Bild ----------------------------------------------------------
     Es gibt genau ein Foto je Modell — das aus dem Kundendokument.
     Zeigt es die Puppe nicht ausreichend bekleidet, bleibt es unscharf,
     bis die zweite Altersverifizierung bestanden ist. */
  /* Bilder: Galeriefoto aus dem Kundendokument plus Fotoserie des Herstellers (Drive-Ordner).
     Freizügige Aufnahmen bleiben unscharf, bis die zweite Altersverifizierung bestanden ist. */
  const BILDER = doll.bilder || [];
  let aktuell = 0;
  const freiGeprueft = () => !!(window.DIL_ALTER && window.DIL_ALTER.frei());
  const istGesperrt = b => !!b.explizit && !freiGeprueft();
  const gesperrt = () => istGesperrt(BILDER[aktuell]);

  function paintMain() {
    const b = BILDER[aktuell];
    const img = $('#pMainImg');
    img.src = b.bild;
    img.alt = doll.name;
    const zu = istGesperrt(b);
    $('.pmain').classList.toggle('is-locked', zu);
    $('#pMainCap').textContent = zu
      ? 'Freizügige Aufnahme — nach Altersverifizierung sichtbar'
      : (BILDER.length > 1 ? `${doll.name} · ${aktuell + 1} / ${BILDER.length}` : doll.name);
    const hinweis = $('#pBlurNote');
    if (hinweis) hinweis.hidden = !BILDER.some(istGesperrt);
    const leiste = $('#pThumbs');
    if (leiste && BILDER.length > 1 && leiste.children.length === BILDER.length) {
      Array.from(leiste.children).forEach((t, i) => { t.classList.toggle('is-active', i === aktuell); t.classList.toggle('is-locked', istGesperrt(BILDER[i])); });
    } else if (leiste && BILDER.length > 1) {
      leiste.hidden = false;
      leiste.innerHTML = BILDER.map((x, i) => `
        <button type="button" class="pthumb${i === aktuell ? ' is-active' : ''}${istGesperrt(x) ? ' is-locked' : ''}" data-i="${i}" aria-label="Bild ${i + 1}">
          <img src="${x.klein || x.bild}" alt="" loading="lazy">
        </button>`).join('');
    }
  }
  if ($('#pThumbs')) $('#pThumbs').addEventListener('click', e => {
    const t = e.target.closest('.pthumb'); if (!t) return;
    aktuell = +t.dataset.i; paintMain();
  });

  /* Bild-Slider: Pfeile, Wischen, Tastatur (Marcel 21.10.2026) */
  const pmain = $('.pmain');
  function blaettern(r) {
    if (BILDER.length < 2) return;
    aktuell = (aktuell + r + BILDER.length) % BILDER.length; paintMain();
    const a = $('#pThumbs .pthumb.is-active');
    if (a) a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  if (pmain && BILDER.length > 1) {
    pmain.insertAdjacentHTML('beforeend',
      '<button type="button" class="pmain__pfeil pmain__pfeil--zurueck" aria-label="Vorheriges Bild">‹</button>' +
      '<button type="button" class="pmain__pfeil pmain__pfeil--weiter" aria-label="Nächstes Bild">›</button>');
    pmain.querySelector('.pmain__pfeil--zurueck').addEventListener('click', e => { e.stopPropagation(); blaettern(-1); });
    pmain.querySelector('.pmain__pfeil--weiter').addEventListener('click', e => { e.stopPropagation(); blaettern(1); });
    let x0 = null;
    pmain.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    pmain.addEventListener('touchend', e => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) blaettern(dx < 0 ? 1 : -1);
    });
    document.addEventListener('keydown', e => {
      if (/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) || !$('#verify').hidden) return;
      if (e.key === 'ArrowRight') blaettern(1); if (e.key === 'ArrowLeft') blaettern(-1);
    });
  }

  // Klick auf ein unscharfes Bild öffnet die Altersverifizierung
  $('#pMainImg').addEventListener('click', () => {
    if (gesperrt() && window.DIL_ALTER) window.DIL_ALTER.oeffne();
  });

  /* --- Textinhalte --------------------------------------------------- */
  $('#crumbName').textContent = doll.name;
  $('#pName').textContent = doll.name;
  $('#pClaim').textContent = doll.claim;
  $('#pQuote').textContent = doll.quote ? '„' + doll.quote + '“' : '';
  $('#pUvp').textContent = doll.uvp ? 'UVP ' + doll.uvp : '';
  $('#pPrice').textContent = doll.price || '';
  $('#pBullets').innerHTML = (doll.bullets || []).map(b => {
    const i = b.indexOf(':');
    return i > 0
      ? `<li><strong>${b.slice(0, i + 1)}</strong>${b.slice(i + 1)}</li>`
      : `<li>${b}</li>`;
  }).join('');
  $('#pLead').innerHTML = (doll.lead || []).map(p => String(p).trim()).filter(Boolean).map(p => `<p>${p}</p>`).join('');
  $('#pCta').textContent = doll.cta || '';
  $('#pConfig').innerHTML = (doll.config || []).map(c => `<li>${c}</li>`).join('');
  $('#pDelivery').textContent = doll.note || ''; paintMain();

  /* Maße und Gewicht aus der Herstellerliste (nur wenn das Modell zugeordnet ist) */
  const m = doll.masse;
  if (m && $('#pMasse')) {
    const z = v => String(v).replace('.', ',');
    const zeilen = [
      ['Körpergröße', m.groesse && m.groesse + ' cm'],
      ['Gewicht', m.gewicht && 'ca. ' + z(Math.round(m.gewicht)) + ' kg'],
      ['Körbchen', m.koerbchen],
      ['Brust / Taille / Hüfte', m.brust && m.taille && m.huefte && `${z(m.brust)} / ${z(m.taille)} / ${z(m.huefte)} cm`],
      ['Modell beim Hersteller', doll.herstellercode]
    ].filter(x => x[1]);
    $('#pMasse').innerHTML = zeilen.map(([k, v]) => `<dt>${k}</dt><dd>${v}</dd>`).join('');
    $('#pMasseBox').hidden = false;
  }

  /* --- Weitere Modelle ------------------------------------------------ */
  const others = (window.DIL_WEITERE || []).filter(d => d.slug !== doll.slug).sort(() => Math.random() - .5).slice(0, 6);
  if ($('#moreGrid')) $('#moreGrid').innerHTML = others.map(d => `
    <a class="tile" href="${d.url}" aria-label="${d.name}">
      <img src="${d.image}" alt="${d.name}" loading="lazy">
      <span class="tile__frame" aria-hidden="true"></span>
      <span class="tile__name">${d.name}</span>
    </a>`).join('');

  /* --- Altersverifizierung liegt in verify.js ------------------------- */
  if (window.DIL_ALTER) window.DIL_ALTER.beiFreigabe(paintMain);
  const btnV = $('#btnVerify');
  if (btnV) btnV.setAttribute('data-verify','');

  /* --- Kaufen ---------------------------------------------------------- */
  const num = s => parseFloat(String(s).replace(/[^\d,]/g,'').replace(',','.')) || 0;
  const euro = n => n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €';
  const basis = doll.preisCent / 100;

  /* Ausstattungsoptionen (optionen.js): Herstellerpreis × 2 */
  /* Preise und Varianten kommen aus Shopify (Produkt „Ausstattungsoptionen“) */
  const VAR = window.DIL_OPTION_VARIANTEN || {};
  const GRUPPEN = (window.DIL_OPTIONEN || []).map(g => ({ ...g, optionen: g.optionen
    .filter(o => VAR[o.id])
    .map(o => ({ ...o, preis: VAR[o.id].preis / 100, variant: VAR[o.id].variant })) }))
    .filter(g => g.optionen.length);
  const OPT = GRUPPEN.flatMap(g => g.optionen);
  const body = $('#optsBody');
  const INFO = window.DIL_OPTION_INFO || {};
  const frei = () => !(window.DIL_ALTER && !window.DIL_ALTER.frei());
  const infoHtml = (o, i) => `
    <div class="optinfo__panel" id="oi-${o.id}" hidden>
      ${i.bild ? `<figure class="optinfo__bild${i.explizit ? ' is-explizit' : ''}${i.explizit && !frei() ? ' is-locked' : ''}">
        ${i.explizit && !frei() ? `<img src="${i.bild}" alt="${o.name}" loading="lazy">` : `<a href="${i.bild}" target="_blank" rel="noopener" title="Bild groß ansehen"><img src="${i.bild}" alt="${o.name}" loading="lazy"></a>`}
        ${i.explizit ? '<figcaption>Bild nach Altersverifizierung sichtbar</figcaption>' : ''}</figure>` : ''}
      <p>${i.text}</p>
    </div>`;
  if (body) body.innerHTML = GRUPPEN.map(g => `
    <fieldset class="opts__grp">
      <legend>${g.gruppe}</legend>
      ${g.optionen.map(o => { const i = INFO[o.id]; return `
        <div class="optwrap">
          <label class="optrow">
            <input type="checkbox" value="${o.id}">
            <span class="optrow__name">${o.name}${i ? ` <button type="button" class="optinfo" data-info="${o.id}" aria-expanded="false" aria-controls="oi-${o.id}" aria-label="Mehr zu ${o.name}">i</button>` : ''}</span>
            <span class="optrow__preis">+ ${euro(o.preis)}</span>
          </label>
          ${i && i.auswahl ? `<label class="optsub" id="os-${o.id}" hidden><span>${i.auswahl.label}</span>
            <select data-sub="${o.id}">${i.auswahl.werte.map(w => `<option>${w}</option>`).join('')}</select></label>` : ''}
          ${i ? infoHtml(o, i) : ''}
        </div>`; }).join('')}
    </fieldset>`).join('') +
    '<p class="opts__note">Weitere Wünsche wie individueller Hautton, Make-up oder Tattoo klären wir gern telefonisch.</p>';

  if (body) {
    body.addEventListener('click', e => {
      const btn = e.target.closest('.optinfo');
      if (btn) {
        e.preventDefault();                       // (i) soll die Option nicht an- oder abhaken
        const pnl = document.getElementById('oi-' + btn.dataset.info);
        pnl.hidden = !pnl.hidden;
        btn.setAttribute('aria-expanded', String(!pnl.hidden));
        return;
      }
      if (e.target.closest('.optinfo__bild.is-locked') && window.DIL_ALTER) window.DIL_ALTER.oeffne();
    });
    body.addEventListener('change', e => {
      if (e.target.type !== 'checkbox') return;
      const sub = document.getElementById('os-' + e.target.value);
      if (sub) sub.hidden = !e.target.checked;
    });
    if (window.DIL_ALTER) window.DIL_ALTER.beiFreigabe(() => $$('.optinfo__bild.is-locked', body).forEach(f => f.classList.remove('is-locked')));
  }

  const gewaehlt = () => $$('#optsBody input:checked').map(i => OPT.find(o => o.id === i.value)).filter(Boolean);
  const aufpreis = () => gewaehlt().reduce((s, o) => s + o.preis, 0);
  function menge() { return Math.max(1, parseInt($('#qty').value, 10) || 1); }
  function paintTotal() {
    const n = gewaehlt().length;
    $('#optsSum').textContent = n ? `${n} ${n === 1 ? 'Option' : 'Optionen'} · + ${euro(aufpreis())}` : 'Standard';
    $('#buyTotal').textContent = euro((basis + aufpreis()) * menge());
    if ($('#mbarTotal')) $('#mbarTotal').textContent = $('#buyTotal').textContent;
  }
  $('#qtyMinus').addEventListener('click', () => { $('#qty').value = Math.max(1, menge()-1); paintTotal(); });
  $('#qtyPlus').addEventListener('click',  () => { $('#qty').value = menge()+1; paintTotal(); });
  $('#qty').addEventListener('input', paintTotal);
  if (body) body.addEventListener('change', paintTotal);
  paintTotal();

  $('#btnBuy').addEventListener('click', async function () {
    const sub = o => { const sel = body && body.querySelector(`select[data-sub="${o.id}"]`); return sel ? sel.value : ''; };
    const variante = gewaehlt().map(o => sub(o) ? `${o.name} (${sub(o)})` : o.name).join(' · ') || 'Standardausstattung';
    const gruppe = doll.slug + '-' + Date.now().toString(36);
    const n = menge();
    const items = [{ id: doll.variantId, quantity: n, properties: { Ausstattung: variante, _gruppe: gruppe, _typ: 'puppe' } }]
      .concat(gewaehlt().map(o => ({ id: o.variant, quantity: n, properties: Object.assign(
        { 'Für': doll.name, _gruppe: gruppe, _option: '1' }, sub(o) ? { Auswahl: sub(o) } : {}) })));
    const s = this.querySelector('span'); const alt = s.textContent;
    this.disabled = true; s.textContent = 'Wird hinzugefügt …';
    try {
      await window.DIL_CART.addItems(items);
      s.textContent = 'Im Warenkorb';
    } catch (err) {
      s.textContent = 'Das hat nicht geklappt, bitte erneut versuchen';
    }
    this.disabled = false;
    setTimeout(() => { s.textContent = alt; }, 1800);
  });

  /* --- Handy: Kaufleiste unten, ausgeblendet solange der Kaufbereich sichtbar ist --- */
  const mbar = $('#mbar');
  if (mbar && 'IntersectionObserver' in window) {
    $('#mbarBuy').addEventListener('click', () => $('#btnBuy').click());
    let kaufSichtbar = false, ganzOben = true;
    const zeige = () => mbar.classList.toggle('is-on', !kaufSichtbar && !ganzOben);
    new IntersectionObserver(e => { kaufSichtbar = e[0].isIntersecting; zeige(); }).observe($('.buybox'));
    window.addEventListener('scroll', () => { ganzOben = scrollY < 200; zeige(); }, { passive: true });
  }
})();
